import { Asignacion } from './asignacion';
import { Vlan } from './vlan';
import { TipoAsignacion } from './tipo-asignacion'


export class Solicitud {
  asignacion: Asignacion;
  idVlanSeleccionada: number;
  tipoAsignacion: TipoAsignacion;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/solicitud.ts